document.addEventListener('DOMContentLoaded', () => {
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      const count = event.cartData?.item_count;
      if (typeof count !== 'number') return;
      document.querySelectorAll('.vo-cart-count').forEach((badge) => {
        badge.textContent = count;
        badge.hidden = count === 0;
        badge.closest('a')?.setAttribute('aria-label', `Cart, ${count} items`);
      });
    });

    subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      const current = document.querySelector('.vo-payment-panel');
      const updated = event.data?.html?.querySelector('.vo-payment-panel');
      if (current && updated) current.replaceWith(updated.cloneNode(true));
    });
  }
});
